import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Custom boxShadow and borderWidth keys from tailwind.preset.ts — unknown to twMerge,
// they would not override a `shadow-md` / `border` in the same class list.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ['dropshadow-50', 'card-soft'] }],
      'border-w': [{ border: ['0.75', '1.25', '1.5'] }],
    },
  },
})

/**
 * Merge Tailwind CSS classes with proper precedence
 * 
 * Uses clsx for conditional class handling and tailwind-merge
 * to intelligently merge Tailwind classes (later classes override earlier ones)
 * 
 * @example
 * ```tsx
 * cn('px-2 py-1', 'px-4') // => 'py-1 px-4'
 * cn('text-red-500', isActive && 'text-blue-500') // => 'text-blue-500' if active
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
